import _ from 'lodash';
import {DATETIME_FORMAT_FROM_API} from 'utils/datetime';
import moment from 'moment';

export const YEAR_SPLITTER = 'year_splitter';

export const getDataWithYearSplitters = data => {
  if (_.isEmpty(data)) {
    return [];
  }
  let currYear = _.toNumber(
    moment(data[0].date, DATETIME_FORMAT_FROM_API).format('YYYY')
  );

  return _.reduce(
    data,
    (res: Array<any>, curr) => {
      let temp = _.toNumber(
        moment(curr.date, DATETIME_FORMAT_FROM_API).format('YYYY')
      );

      if (temp > currYear) {
        res.push({year: temp, type: YEAR_SPLITTER});
      }

      res.push(curr);
      currYear = temp;
      return res;
    },
    [{year: currYear, type: YEAR_SPLITTER}]
  );
};
